export default __webpack_public_path__ + "assets/images/3d359dfae602a26193f481822207d215.png";